import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Ripple from 'vuetify/lib/directives/ripple';

Vue.use(Vuetify, {directives: {Ripple}});

export const vuetifyConfig = {
  breakpoint: {
    mobileBreakpoint: 'md', // This is equivalent to a value of 960
  },
  theme: {
    options: {customProperties: true},
    themes: {
      light: {
        primary: '#2b5593',
        secondary: '#607d8b',
        accent: '#4caf50',
        error: '#ff5722',
        errorLight: '#ffc0ac',
        warning: '#ff9800',
        warningLight: '#ffd9a1',
        info: '#ffc107',
        success: '#8bc34a',
        save: '#80A957',
        upperHeader: '#184a7b',
        pageTitleHeader: '#f5f8f9',
        boxHeader: '#0e83ea',
        stepHeadColor: '#dfeffc',
        activeRow: '#bcdeab',
        dark: '#000000',
        red: '#ff0000',
        expectColor: '#78909c',
        disabled: '#aaaaaa',
        tableHeader: '#666666',
        tableHeaderActive: '#383838',
        tableHeaderSortArrow: '#9e9e9e',
        'table-border': '#e0e0e0',
        tableBorderDeactivated: '#a8a8a8',
        tableRowHover: '#eeeeee',
        tableRowDeactivated: '#c6c6c6',
        tableRowDeactivatedLight: '#f2f3f4',
        menuItemHover: '#e0e0e0',
        delete: '#b82519',
        white: '#ffffff',
        notTesting: '#00000033',
        'no-records': '#9e9e9e',
        'list-item-cursor': '#dcdcdc',
        'list-item-hover': '#f6f6f6',
        'gray-text': '#666666',
        'gray-text-background': '#dddddd',
        'text-on-gray-text-background': '#585858',
        text: '#ffffff',
        'text-inverted': '#ffffff',
        'tree-text': '#666666',
        'tree-content-border': '#5c9ccc',
        'tree-content-background': '#dbedff',
        separator: '#8e8e8e',
        'box-border': '#9e9e9e',
        'row-item-hover': '#5c9ccc',
        'headline-box-light': '#dfeffc',
        'system-bar': '#184a7b',
        'background': '#ffffff',
        total:'#6E7FA1',
        pending: '#818181',
        testStatusRunning: '#61A3C5',
        testStatusAborted: '#4E7D4E',
        testStatusMaxRuntime: '#D9D9D9',
        ok: '#91C66D',
        testStatusRuntimeWarning: '#FDEDAF',
        testStatusWarning: '#FDD184',
        testStatusRuntimeError: '#FEB356',
        testStatusError: '#E95300',
      },
      dark: {
        primary: '#525050',
      },
    },
  },
};

export default new Vuetify(vuetifyConfig);
